import { faLink, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const ProjectRow = ({ project, index, setDeleteProject  }) => {

    const { name, role, url, coverImg } = project;
    
    return (
        <tr>
            <th>{index + 1}</th>
            <td>
                <img className='h-20' src={coverImg} alt='project_coverImg' />
            </td>
            <td className='font-bold text-green-500'>{name}</td>
            <td className='font-bold' >{role}</td>
            <td> <a href={url} target="_blank" rel="noopener noreferrer"><button class="btn btn-xs bg-secondary border-0 text-white "> <FontAwesomeIcon className='mr-1' icon={faLink} /> Live Link</button></a> </td>
            <td onClick={() => setDeleteProject(project)} >
                <label setDeleteProject={setDeleteProject} htmlFor="delete-Confirm-Modal" className="btn btn-sm border-0 bg-red-300 text-red-500  modal-button">
                    Delete <FontAwesomeIcon className='ml-2' icon={faTrashCan} />
                </label>
            </td>
        </tr>
    );
};

export default ProjectRow;